/**
 * Hero Search - Clear button functionality
 */

( function () {
	'use strict';

	/**
	 * Initialize hero search clear button
	 */
	function initHeroSearch() {
		const heroSearch = document.querySelector( '.hero-search' );

		if ( !heroSearch ) {
			return;
		}

		const searchInput = heroSearch.querySelector( '.hero-search__search-input' );
		const clearBtn = heroSearch.querySelector( '.hero-search__clear-btn' );

		if ( !searchInput || !clearBtn ) {
			return;
		}

		// Handle clear button click
		clearBtn.addEventListener( 'click', function ( e ) {
			e.preventDefault();
			searchInput.value = '';
			searchInput.focus();
			clearBtn.style.display = 'none';
		} );

		// Show/hide clear button based on input value
		searchInput.addEventListener( 'input', function () {
			if ( this.value.trim() !== '' ) {
				clearBtn.style.display = 'flex';
			} else {
				clearBtn.style.display = 'none';
			}
		} );

		// Ensure clear button visibility on page load matches input state
		if ( searchInput.value.trim() === '' ) {
			clearBtn.style.display = 'none';
		} else {
			clearBtn.style.display = 'flex';
		}
	}

	// Initialize on DOM ready
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initHeroSearch );
	} else {
		initHeroSearch();
	}
} )();
